module.exports = __webpack_public_path__ + "static/media/star.8da642a7.png";